<template>
  <v-snackbar v-model="snackShow" :color="snackColor" :timeout="4000" :vertical="true" top>
      {{ messageToShow }}
      <v-btn dark flat @click="closeSnack">
        Cerrar
      </v-btn>
    </v-snackbar>
</template>

<script>
export default {
  props: ['error', 'message', 'showSnack'],
  data() {
    return {
      snackShow: false,
      snackColor: 'green',
      snackMessage: '',
      errorStatus: '',
    };
  },
  computed: {
    messageToShow() {
      let messageToShow = this.message;
      if (this.message.response) {
        messageToShow = this.message.response.data.message;
      }
      return messageToShow;
    },
  },
  watch: {
    showSnack() {
      this.snackShow = this.showSnack;
    },
    snackShow() {
      if (!this.snackShow) {
        this.$emit('close-snack');
      }
    },
    error() {
      if (this.error) {
        this.snackColor = 'red';
      } else {
        this.snackColor = 'green';
      }
    },
  },
  methods: {
    closeSnack() {
      this.snackShow = false;
      this.$emit('close-snack');
    },
  },
};
</script>